import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-smoke-900 text-smoke-300 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img 
                src="/android-chrome-192x192.png" 
                alt="BBQLabs.ai" 
                className="h-6 w-auto"
              />
              <span className="text-xl font-bold text-white">BBQLabs.ai</span>
            </div>
            <p className="text-sm text-smoke-400">
              Precision planning powered by thermodynamics and real-time weather data.
            </p>
            <p className="text-xs text-smoke-500 mt-3">
              A product of <a href="https://escapevelo.com" target="_blank" rel="noopener noreferrer" className="text-flame-400 hover:text-flame-300">Escape Velocity Ventures</a>
            </p>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="hover:text-flame-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-flame-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a 
                  href="https://escapevelo.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-flame-400 transition-colors"
                >
                  About Escape Velocity
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-3">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/how-it-works" className="hover:text-flame-400 transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:feedback@escapevelo.com" 
                  className="hover:text-flame-400 transition-colors"
                >
                  Send Feedback
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer & Copyright */}
        <div className="border-t border-smoke-800 mt-8 pt-6 text-xs text-smoke-500">
          <p className="mb-2">
            ⚠️ <strong className="text-smoke-400">Food Safety Disclaimer:</strong> Cook time estimates are for reference only. 
            Always use a calibrated meat thermometer to verify internal temperature. We are not liable for foodborne illness.
          </p>
          <p>
            © {currentYear} Escape Velocity Ventures. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
